export default __webpack_public_path__ + "static/media/surginghealth.c68ee908.png";